import React from "react";
import './style.css';

/**
 * Reusable container of Patient Name & Patient ID
 * @param {string} name - name of the patient 
 * @param {number} patientId - patientId
 */
const PatientName = ({name, patientId}) => {
  return (
      //Container of patient name & id
      <div className="modal-patient-name">
        <h6 className="h6-400 dark-grey">{name}</h6>
        <p className="body2 medium-grey">({patientId})</p>
      </div>
  );
};

export default PatientName;
